<div>
  <svg-icon src="assets/icons/image.svg"></svg-icon>
  <span class="ml-px-8">x{{ count }}</span>
</div>
